import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TransactionType, Response } from '@ui/src';
import { transactionStatusApi } from './service';
import {
  TransactionStatusReport,
  TransactionStatusReportResponse,
} from '../types';
import calculateTotal from '../helpers/calculate-total';

export interface TransactionsStatusState {
  transactionTypes?: TransactionType[];
  transactionsStatus?: TransactionStatusReport[];
  errorsList?: string;
}

const initialState: TransactionsStatusState = {};

export const transactionsStatusSlice = createSlice({
  name: 'transactionsStatus',
  initialState,
  reducers: {
    clearReport: (state) => {
      state.transactionsStatus = undefined;
      state.errorsList = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      transactionStatusApi.endpoints.getTransactionStatusReport.matchPending,
      (state) => {
        state.errorsList = undefined;
      },
    );
    builder.addMatcher(
      transactionStatusApi.endpoints.getTransactionStatusReport.matchRejected,
      (state, action: any) => {
        state.transactionsStatus = undefined;

        if (action?.payload.data) {
          if (Array.isArray(action?.payload.data?.message)) {
            state.errorsList = action?.payload.data?.message
              ?.map((item: { value: string }) => item.value)
              .join('; ');
          } else {
            state.errorsList = action?.payload.data?.error;
          }
        }
      },
    );
    builder.addMatcher(
      transactionStatusApi.endpoints.getTransactionStatusReport.matchFulfilled,
      (
        state,
        action: PayloadAction<{ data: TransactionStatusReportResponse }>,
      ) => {
        state.transactionsStatus = calculateTotal(action.payload.data.stats);
      },
    );
    builder.addMatcher(
      transactionStatusApi.endpoints.getReportsTransactionsTypes.matchFulfilled,
      (state, action: PayloadAction<Response<TransactionType>>) => {
        state.transactionTypes = action.payload.data.edges?.map(
          (item) => item.node,
        );
      },
    );
  },
});

export const { clearReport } = transactionsStatusSlice.actions;

export default transactionsStatusSlice.reducer;
